<template>
  <el-popover
      v-model="visible"
      :placement="placement"
      width="220">
    <div style="margin: 16px 0px;">
      This will send a request to the chime to play a sound
    </div>
    <div style="display: flex; justify-content: space-between; align-items: center; margin: 0">
      <el-button
          size="small"
          type="default"
          @click="playSound('ding')">
        Play Ding
      </el-button>
      <el-button
          size="small"
          type="primary"
          @click="playSound('motion')">
        Play Motion
      </el-button>
    </div>
    <el-button
        slot="reference"
        type="text">
      Play Sounds Test
    </el-button>
  </el-popover>
</template>

<script>
export default {
  name: "PlaySoundsTest",
  props: {
    placement: {
      type: String,
      default: "bottom",
    },
  },
  data() {
    return {
      visible: false,
    };
  },
  computed: {},
  methods: {
    playSound(type) {
      const done = () => {
        this.visible = false;
      };
      this.$emit("execute", type, done);
    },
  },
};
</script>

<style scoped></style>
